import React, { useEffect, useState } from "react";
import {
  CircularAvatar,
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { EmptyList } from "../../../assets/images";
import { RootState } from "../../../redux/rootReducers";
import {
  getAllFinacClientUsersAction,
  resetSession,
} from "../../../redux/auth";
import {
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsStatusCode,
  resetHrmsSuccess,
} from "../../../redux/hrms";
import { connect } from "react-redux";
import { LeaveAndWFHListPayloadType } from "../../../commonTypes/stcoToolsType";
import {
  getLeaveAndWFHListAction,
  resetLeaveAndWFHList,
} from "../../../redux/stcoTools";
import { LeaveAndUpcomingHistoryListType, LeaveStatus } from "../../../redux/stcoTools/stcoToolsType";
import Select from "react-select";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { components } from "react-select";
import AllUserLeaveHistoryTable from "../../../components/HRMS/AllUserLeaveHistoryTable";

type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
type AppProps = {
  token: string | null;
  success: number | null;
  fetching: boolean;
  error: string | null | undefined;
  message: string | null | undefined;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  dispatchResetHrmsStatusCode: () => void;
  dispatchLeaveAndWFHHistoryListAction: (
    data: LeaveAndWFHListPayloadType
  ) => void;
  leaveAndWFHHistoryList: [] | LeaveAndUpcomingHistoryListType[];
  dispatchResetLeaveAndWFHListAction: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  totalUserCount: number | string | any;
  finacUsersList: any;
  leaveTotalCount: number;
  balanceLeave: LeaveStatus;
  approvedLeave: number;
};
const AllUsersLeaveHistoryReport = ({
  token,
  success,
  fetching,
  error,
  message,
  statusCode,
  dispatchResetSession,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsMessage,
  dispatchResetHrmsError,
  dispatchResetHrmsStatusCode,
  dispatchLeaveAndWFHHistoryListAction,
  leaveAndWFHHistoryList,
  dispatchResetLeaveAndWFHListAction,
  dispatchGetAllFinacUsersAction,
  totalUserCount,
  finacUsersList,
  leaveTotalCount,
  balanceLeave,
  approvedLeave,
}: AppProps) => {
  const [userSelected, setUserSelected] = useState<any>({
    value: null,
    label: "Select User",
  });
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [finalUserList, setFinalUserList] = useState<DropDownItemType[] | []>(
    []
  );
  const [text, setText] = useState<string>("");
  const [showData, setShowData] = useState(false);
  const [data, setData] = useState<[] | LeaveAndUpcomingHistoryListType[]>([]);

  const handleChangeUser = (client: any) => {
    setUserSelected(client);
  };
  const [loadCondition, setLoadCondition] = useState(true);
  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv) => prv + limit);
  };
  const onMenuClose = () => setLoadCondition(true);

  useEffect(() => {
    dispatchResetLeaveAndWFHListAction();
    dispatchResetHrmsSuccess();
    dispatchResetHrmsMessage();
    dispatchResetHrmsError();
    dispatchResetHrmsStatusCode();
  }, []);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: text,
        user_type: "stco_users",
        limit,
        offset,
        status: "1",
      };

      if (+finacUsersList?.total_count) {
        if (+finacUsersList?.total_count > offset) {
          dispatchGetAllFinacUsersAction(finalData);
        }
      } else {
        dispatchGetAllFinacUsersAction(finalData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: "",
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  useEffect(() => {
    if (finacUsersList?.data?.length > 0) {
      if (offset <= +finacUsersList?.total_count) {
        let finalUserData = finacUsersList?.data?.map((user: any) => {
          return {
            value: user.user_id,
            label: `${user.first_name} ${user.last_name}`,
            image: user?.profile_pic?.file_url,
          };
        });
        if (offset > 0) {
          setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
          setFinalUserList([...finalUserData]);
        }
      }
    }
  }, [finacUsersList?.data]);

  useEffect(() => {
    if (leaveAndWFHHistoryList?.length === 0) {
      setData(leaveAndWFHHistoryList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...leaveAndWFHHistoryList]);
    } else {
      setData(leaveAndWFHHistoryList);
    }
  }, [leaveAndWFHHistoryList]);

  const handleSubmit = (id: string | null) => {
    setShowData(true);
    dispatchResetLeaveAndWFHListAction();
    if (token) {
      let finalData = {
        token,
        status: "3",
        user_type: "employee",
        limit,
        offset,
        type: "leave",
        userId: id,
      };
      dispatchLeaveAndWFHHistoryListAction(finalData);
    }
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          {data?.label}
        </div>
      </components.Option>
    );
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetHrmsError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="All User Leave History Report" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header pb-0">
            <div className="left-header">
              <div className="heading">All User Leave history List </div>
            </div>
          </div>
          <div>
            <div className="d-flex align-items-start mb-3">
              <div className="col-md-3 pl-3 form-group d-flex flex-column p-0">
                <label className="mb-1">
                  Select User <span className="color-red">*</span>
                </label>
                <Select
                  options={finalUserList}
                  value={userSelected}
                  components={{ Option }}
                  cacheOptions
                  onChange={handleChangeUser}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  onInputChange={(e: string) => {
                    setLoadCondition(false);
                    setText(e);
                    setOffset(0);
                  }}
                  onMenuClose={onMenuClose}
                  isLoading={!loadCondition && fetching}
                />
              </div>

              <div className="ml-3" style={{ marginTop: "29px" }}>
                <button
                  className="btn btn-primary pl-3 pb-2"
                  disabled={!userSelected?.value}
                  onClick={() => handleSubmit(userSelected?.value)}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
          {fetching && offset == 0 ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : leaveAndWFHHistoryList?.length > 0 ? (
            <>
              <span
                style={{
                  borderRadius: "16px",
                  marginLeft: "17px",
                  background:
                    balanceLeave?.balance_leave -
                      balanceLeave?.approved_leave ===
                    0
                      ? "#fde0d3"
                      : "#e7f0d4",
                  color:
                    balanceLeave?.balance_leave -
                      balanceLeave?.approved_leave ===
                    0
                      ? "#e7733e"
                      : "#82b01f",
                }}
                className={`status-incomplete ml-4`}
              >
                Leave Balance ={" "}
                {balanceLeave?.balance_leave - balanceLeave?.approved_leave < 0 ? "0":balanceLeave?.balance_leave - balanceLeave?.approved_leave}
              </span>
              <AllUserLeaveHistoryTable
                data={data}
                fetching={fetching}
                offset={offset}
                balanceLeave={balanceLeave}
                approvedLeave={approvedLeave}
              />
            </>
          ) : (
            <div className="mt-5 pb-5">
              {!fetching && data?.length === 0 && (
                <EmptyListPage
                  title="No Leave History Found!"
                  image={EmptyList}
                  imageWidth="30%"
                />
              )}
            </div>
          )}
        </div>
        {handleErrorModal()}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.hrms.success,
  statusCode: state.hrms.statusCode,
  error: state.hrms.error,
  message: state.hrms.message,
  fetching: state.stcoTools.fetching,
  finacUsersList: state.auth.finacClientUsersList,
  totalUserCount: state.auth.totalUserCount,
  leaveAndWFHHistoryList: state.stcoTools.leaveAndWFHHistoryList,
  leaveTotalCount: state.stcoTools.leaveTotalCount,
  balanceLeave: state.stcoTools.balanceLeave,
  approvedLeave: state.stcoTools.approvedLeave,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchResetHrmsStatusCode: () => dispatch(resetHrmsStatusCode()),
  dispatchLeaveAndWFHHistoryListAction: (data: LeaveAndWFHListPayloadType) =>
    dispatch(getLeaveAndWFHListAction(data)),
  dispatchResetLeaveAndWFHListAction: () => dispatch(resetLeaveAndWFHList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacClientUsersAction(data)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUsersLeaveHistoryReport);
